import Notification from './notification.container'

export default Notification